export const SET_CURRENT_TIME = 'SET_CURRENT_TIME';
export const SET_USER_TIME = 'SET_USER_TIME';
export const RESET_CURRENT_TIME = 'RESET_CURRENT_TIME';

export default {
  SET_CURRENT_TIME,
  SET_USER_TIME,
  RESET_CURRENT_TIME,
};
